export default __webpack_public_path__ + "static/media/Nut_new.256.b6f4f26c.png";